import { render } from "./RefundDispute.vue?vue&type=template&id=e8d95ace&scoped=true"
import script from "./RefundDispute.vue?vue&type=script&lang=js"
export * from "./RefundDispute.vue?vue&type=script&lang=js"

import "./RefundDispute.vue?vue&type=style&index=0&id=e8d95ace&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8d95ace"]])

export default __exports__